import React from "react";
import styles from "../pages/(private)/Chamado.module.css";
import { TIPOS_SOLICITACAO } from "../types/types";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const TipoSolicitacaoField: React.FC<Props> = ({ value, onChange }) => (
  <div className={`${styles.field} ${styles.fullWidth}`}>
    <label className={styles.label}>
      O tipo de solicitação/chamado é: <span className={styles.required}>*</span>
    </label>

    <div className={styles.radioGroup}>
      {TIPOS_SOLICITACAO.map((label, index) => {
        const id = `tipo-solicitacao-${index}`;
        return (
          <div className={styles.radioOption} key={id}>
            <input
              className={styles.radioInput}
              type="radio"
              name="tipo_solicitacao"
              id={id}
              value={label}
              checked={value === label}
              onChange={(e) => onChange(e.target.value)}
            />
            <label className={styles.radioLabel} htmlFor={id}>
              {label}
            </label>
          </div>
        );
      })}
    </div>
  </div>
);

export default TipoSolicitacaoField;
